﻿export class GenericEvent {
    static eventName() { return 'GenericEvent'; }

    eventName = GenericEvent.eventName;

    name: string;
    payload: string;

    constructor(name: string, payload: string) {
        this.name = name;
        this.payload = payload;
    }
}